import { MEASUREMENT_ID } from 'features/analytics/analytics';

// Loads gtag.js ON DEMAND, and only ever after consent.
//
// Previously the tag was hard-coded into public/index.html with `async src=...`
// plus an immediate gtag('config'), which meant the request to
// googletagmanager.com and the _ga cookie both happened before a German visitor
// had been asked anything — the exact thing §25(1) TDDDG prohibits. The script
// element is now created here, once, at the moment consent is granted.

let injected = false;

function ensureGtagStub() {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
}

// Google Consent Mode v2 defaults. Declared BEFORE the tag loads so that if the
// tag is ever loaded by some other path, it still starts from a denied state.
export function initConsentMode() {
  ensureGtagStub();
  window.gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
    functionality_storage: 'granted',
    security_storage: 'granted',
    wait_for_update: 500,
  });
}

export function updateConsentMode({ analytics, marketing }) {
  ensureGtagStub();
  window.gtag('consent', 'update', {
    analytics_storage: analytics ? 'granted' : 'denied',
    ad_storage: marketing ? 'granted' : 'denied',
    ad_user_data: marketing ? 'granted' : 'denied',
    ad_personalization: marketing ? 'granted' : 'denied',
  });
}

export function loadAnalytics() {
  if (injected || typeof document === 'undefined') return;
  injected = true;

  ensureGtagStub();

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.gtag('js', new Date());
  // Consent arrives after the first render, so the config call here is what
  // sends the initial page_view that index.html used to send on load.
  window.gtag('config', MEASUREMENT_ID, {
    anonymize_ip: true,
    page_path: window.location.pathname,
  });
}

// Applies a consent record to the tag: grant → load and signal granted;
// deny → signal denied. Never unloads a script that is already in the page, so
// a withdrawal additionally clears the cookies (see consentStore) and the caller
// reloads for a clean state.
export function applyConsent(consent) {
  updateConsentMode(consent);
  if (consent.analytics) loadAnalytics();
}

export function __resetForTests() {
  injected = false;
}
